import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { App, Head, Link, plugin } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress'

Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(plugin)
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.component('InertiaHead', Head)
Vue.component('InertiaLink', Link)
Vue.prototype.THEME = THEME

InertiaProgress.init()

let siteName = '';
switch(THEME) {
  case 'ACLARS':
    siteName = 'ACLARS Conference Manager';
    break;
  case 'ICLRS':
  default:
    siteName = 'ICLRS Conference Manager';
    break;
}


const el = document.getElementById('app')

new Vue({
  metaInfo: {
    titleTemplate: title => (title ? `${title} - ${siteName}` : siteName),
  },
  render: h =>
    h(App, {
      props: {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: name => require(`./Pages/${name}`).default,
      },
    }),
}).$mount(el)